import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ProductsListController from '../productslist/ProductsListController'
import { ContentFooter } from '../../layout/Content'
import RegisterProductFooterStyle from './css/RegisterProductFooterStyle'
import { appContext } from '../../../App'
import { registerProductControllerContext } from './RegisterProductController'
import ModalWindow from '../../layout/modalwindow/ModalWindow'

function RegisterProductFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const registerProductController = useContext(registerProductControllerContext)
  const { saveProduct } = registerProductController
  const product = registerProductController.product[0]
  let mode = product._id ? 'edit' : 'add'

  const showMessageBox = () => {
    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        header='Record not saved'
        footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>This product already exist!</div>
              <br />
              <div>Modify the details to make it more distinct then try again.</div>
            </div>
            <div className='button-container'>
              <button
                onClick={() => {
                  ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
                  document.getElementById('item-brand').focus()
                }}
                className='pospro-action-btn top-anchor'>
                Ok
              </button>
            </div>
          </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickSave = async (e) => {
    const save_product = await saveProduct(app, product)
    if (save_product !== -1) {
      setContent(<ProductsListController />)
    } else showMessageBox()
  }

  const getSaveUpdateButtonCaption = () => {
    if (mode === 'add')
      return ( <span>&nbsp;Save</span> )
    else
      return ( <span>&nbsp;Update</span> )
  }

  return (
    <ContentFooter>
      <div className='regprod-button-container'>
        <button className="pospro-action-btn"
          id="products-list-btn"
          type="button"
          onClick={() => setContent(<ProductsListController />)}>
          <FontAwesomeIcon icon='list-alt'/>&nbsp;Products List
        </button>
        <button className={(product.units.length) ? "pospro-action-btn" : 'pospro-action-btn disabled-button'}
          disabled={!Boolean(product.units.length)}
          id="save-item-btn"
          type="button"
          onClick={onClickSave}>
          <FontAwesomeIcon icon='save'/>{getSaveUpdateButtonCaption()}
        </button>
      </div>
      <RegisterProductFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(RegisterProductFooter)